import { useState } from "react";
import { ChevronDown, ExternalLink } from "lucide-react";
import { StatusBadge } from "./_ui";

const money = (cents) => `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const day = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "—");
const BADGE = { transferred: "sent", paid: "approved", cancelled: "closed", failed: "rejected", held: "pending" };
const LABEL = { transferred: "Sent", paid: "Deposited", cancelled: "Cancelled", failed: "Failed", held: "Held" };

/** Collapsible list of grants that have left the weekly queue. */
export const GrantHistory = ({ items = [], livemode }) => {
  const [open, setOpen] = useState(false);
  if (!items.length) return null;
  const dashBase = livemode ? "https://dashboard.stripe.com" : "https://dashboard.stripe.com/test";
  return (
    <div className="mt-10" data-testid="grant-history">
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid="grant-history-toggle" className="flex w-full items-center justify-between rounded-lg border border-border bg-bone px-5 py-3 text-left">
        <span className="text-sm font-medium text-ink">History · {items.length} grant{items.length === 1 ? "" : "s"}</span>
        <ChevronDown className={`h-4 w-4 text-olive transition-transform ${open ? "rotate-180" : ""}`} strokeWidth={2} />
      </button>
      {open && (
        <ul className="mt-3 divide-y divide-ink/10 rounded-xl border-2 border-ink/10 bg-bone">
          {items.map((g) => (
            <li key={g.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-3" data-testid={`grant-history-row-${g.id}`}>
              <div className="min-w-0">
                <p className="truncate font-serif text-base text-ink">
                  {g.student_name} <span className="text-olive">· {g.campaign_title}</span>
                </p>
                <p className="mt-0.5 text-xs text-olive">
                  {g.state === "paid" ? `deposited ${day(g.paid_at)}` : g.state === "transferred" ? `sent ${day(g.transferred_at)}` : day(g.created_at)}
                  {g.memo ? ` · “${g.memo}”` : ""}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-serif text-lg text-ink">{money(g.amount_cents)}</span>
                <StatusBadge status={BADGE[g.state] || "pending"} />
                <span className="sr-only">{LABEL[g.state]}</span>
                {g.stripe_transfer_id && (
                  <a href={`${dashBase}/connect/transfers/${g.stripe_transfer_id}`} target="_blank" rel="noreferrer" data-testid={`grant-history-stripe-${g.id}`} className="text-olive hover:text-ink" title="Open in Stripe">
                    <ExternalLink className="h-4 w-4" strokeWidth={2} />
                  </a>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
